import {
  Avatar,
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import DeleteIcon from "@material-ui/icons/Delete";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HelpIcon from "@material-ui/icons/Help";
import PropTypes from "prop-types";
import React from "react";
import { languages } from "../../constants/languages";
import TiebreakerDefaults from "../../constants/TiebreakerDefaults";
import Tiebreakers from "../../constants/Tiebreakers";
import CustomPointsContainer from "../../containers/structure/CustomPointsContainer";
import TiebreakersContainer from "../../containers/structure/TiebreakersContainer";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  heading: {
    fontWeight: 500,
  },
  noWrapDesktop: {
    [theme.breakpoints.up("sm")]: {
      flexWrap: "nowrap !important",
      justifyContent: "space-around",
    },
  },
});

const ScoreType = ({ props, typeKey, typeNum }) => {
  const { classes } = props;
  const scoreType =
    typeNum === 1
      ? props.tournament
      : (props.tournament.scoringTypes || {})[typeKey] || {};

  const useSets = (scoreType.useSets || "0") === "1";
  let tiebreakers = [];
  if (scoreType.tiebreakers !== undefined) {
    tiebreakers = scoreType.tiebreakers.filter((t) =>
      t.custom
        ? (props.tournament.customPoints || {})[t.id] !== undefined
        : true
    );
  } else if (useSets) {
    tiebreakers = TiebreakerDefaults["2"].criteria;
  } else if (
    (scoreType.scoreCalculationType === undefined ||
      scoreType.scoreCalculationType === 0) &&
    scoreType.tiebreakerCriteria === undefined
  ) {
    tiebreakers = TiebreakerDefaults["0"].criteria;
  } else if (scoreType.scoreCalculationType === 1) {
    tiebreakers = TiebreakerDefaults["1"].criteria;
  }

  let possibleResults = [];
  let num = Number(scoreType.numSets || "2");

  if (
    scoreType.playOff &&
    Number(scoreType.numSets || "2") % 2 !== 0 &&
    Number(scoreType.numSets || "2") > 1
  ) {
    for (let i = 0; i < Math.round(num / 2); i++) {
      possibleResults.push(
        Math.round(num / 2).toString() +
          "-" +
          Math.round(num / 2 - (i + 1)).toString()
      );
    }
  } else {
    for (let i = 0; i < Math.round(num / 2); i++) {
      possibleResults.push((num - i).toString() + "-" + i.toString());
    }

    if (num % 2 === 0 && (scoreType.decidingSet || false)) {
      possibleResults.push(
        (num / 2 + 1).toString() + "-" + (num / 2).toString()
      );
    }
  }

  const parsePoints = (val) => {
    return val === undefined || val === null || val === "" ? 3 : Number(val);
  };

  const bigWinPoints = parsePoints(scoreType.pointsBigWin);
  const winPoints = parsePoints(scoreType.pointsWin);

  const showWarning = bigWinPoints < winPoints;

  return (
    <Card style={{ marginBottom: 5 }}>
      <CardHeader
        style={{
          padding: "10px 15px",
          borderBottom: "1px solid rgb(236, 239, 241)",
        }}
        avatar={
          <Avatar
            variant="rounded"
            aria-label="number"
            style={{ fontWeight: 500 }}
          >
            {typeNum}
          </Avatar>
        }
        action={
          typeNum === 1 ? (
            <div
              style={{
                backgroundColor: "rgb(236, 239, 241)",
                borderRadius: 5,
                padding: "8px 10px",
                marginTop: 10,
                marginRight: 8,
                display: "flex",
              }}
            >
              {languages.signupPage.default}
              <Tooltip
                disableFocusListener
                title={languages.structure.defaultScoringTooltip}
              >
                <HelpIcon
                  style={{ color: "grey", fontSize: 20, marginLeft: 5 }}
                />
              </Tooltip>
            </div>
          ) : props.confirmDelete === typeKey ? (
            <Button
              onClick={(e) => {
                props.handleDeleteScoringType(e, typeKey);
              }}
              color="secondary"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 9.5 }}
            >
              {languages.general.delete}
            </Button>
          ) : (
            <IconButton
              aria-label="edit"
              onClick={(e) => {
                props.handleDeleteScoringType(e, typeKey);
              }}
              style={{ marginTop: 8 }}
            >
              <DeleteIcon />
            </IconButton>
          )
        }
        title={languages.structure.scoring + " " + typeNum}
        subheader={""}
      />
      <CardContent>
        <RadioGroup
          aria-label="position"
          name="useSets"
          value={scoreType.useSets || "0"}
          onChange={(e) => {
            props.handleChange(e, typeKey);
          }}
          row
          style={{ justifyContent: "space-between" }}
        >
          <div>
            <FormControlLabel
              style={{ marginLeft: 0 }}
              value="0"
              control={<Radio color="primary" />}
              label={languages.structure.usePoints}
              labelPlacement="top"
            />
            <FormControlLabel
              value="1"
              control={<Radio color="primary" />}
              label={languages.structure.useSets}
              labelPlacement="top"
            />
          </div>
          {(scoreType.useSets || "0") === "0" && (
            <FormControlLabel
              control={
                <Switch
                  checked={scoreType.advancedGroupRanking || false}
                  onChange={(e, checked) => {
                    props.handleSwitch(e, checked, typeKey);
                  }}
                  color="primary"
                  name="advancedGroupRanking"
                  size="small"
                />
              }
              label={languages.structure.advancedSettings}
            />
          )}
        </RadioGroup>

        {(scoreType.useSets || "0") === "0" && (
          <ExpansionPanelDetails
            style={{
              paddingBottom: 0,
              paddingTop: 10,
              paddingLeft: 0,
              paddingRight: 0,
            }}
          >
            <Typography variant="caption">
              {languages.formatString(
                languages.structure.scoreCountDescription,
                props.tournament.individualPlayers
                  ? languages.teams.playerLow
                  : languages.results.teamLow
              )}
            </Typography>
          </ExpansionPanelDetails>
        )}

        {(scoreType.useSets || "0") === "0" && (
          <div>
            {scoreType.advancedGroupRanking && (
              <>
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <TextField
                    label={languages.structure.pointsBigWin}
                    value={scoreType.pointsBigWin || ""}
                    placeholder="3"
                    name="pointsBigWin"
                    type="number"
                    error={showWarning}
                    helperText={
                      showWarning ? languages.structure.pointsBigWinWarning : ""
                    }
                    onChange={(e) => {
                      props.handleChange(e, typeKey);
                    }}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={scoreType.goalsAsPoints}
                  />
                  <Select
                    style={{
                      width: 150,
                      marginLeft: 20,
                      marginTop: 32,
                    }}
                    value={scoreType.pointsBigWinMargin || "2"}
                    onChange={(e) => {
                      props.handleChange(e, typeKey);
                    }}
                    inputProps={{
                      name: "pointsBigWinMargin",
                      id: "pointsBigWinMargin",
                    }}
                    disabled={scoreType.goalsAsPoints}
                  >
                    <MenuItem value={"2"}>
                      {languages.structure.pointsPlusTwo}
                    </MenuItem>
                    <MenuItem value={"3"}>
                      {languages.structure.pointsPlusThree}
                    </MenuItem>
                    <MenuItem value={"4"}>
                      {languages.structure.pointsPlusFour}
                    </MenuItem>
                    <MenuItem value={"5"}>
                      {languages.structure.pointsPlusFive}
                    </MenuItem>
                  </Select>
                </div>
                <TextField
                  label={languages.structure.pointsWinOnPenalties}
                  value={scoreType.pointsWinOnPenalties || ""}
                  placeholder="3"
                  name="pointsWinOnPenalties"
                  type="number"
                  onChange={(e) => {
                    props.handleChange(e, typeKey);
                  }}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={scoreType.goalsAsPoints}
                />
                <br />
              </>
            )}
            <TextField
              label={languages.structure.pointsWin}
              value={scoreType.pointsWin || ""}
              placeholder="3"
              name="pointsWin"
              type="number"
              onChange={(e) => {
                props.handleChange(e, typeKey);
              }}
              margin="normal"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              disabled={
                scoreType.goalsAsPoints && scoreType.advancedGroupRanking
              }
            />
            <br />
            <TextField
              label={
                scoreType.advancedGroupRanking
                  ? languages.structure.pointsTieWithGoals
                  : languages.structure.pointsTie
              }
              value={scoreType.pointsTie || ""}
              placeholder="1"
              name="pointsTie"
              type="number"
              onChange={(e) => {
                props.handleChange(e, typeKey);
              }}
              margin="normal"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              disabled={
                (scoreType.goalsAsPoints && scoreType.advancedGroupRanking) ||
                (scoreType.noDraw && scoreType.advancedGroupRanking)
              }
            />
            <br />
            {scoreType.advancedGroupRanking && (
              <>
                <TextField
                  label={languages.structure.pointsTieNoGoals}
                  value={scoreType.pointsTieNoGoals || ""}
                  placeholder="1"
                  name="pointsTieNoGoals"
                  type="number"
                  onChange={(e) => {
                    props.handleChange(e, typeKey);
                  }}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={scoreType.goalsAsPoints || scoreType.noDraw}
                />
                <br />
              </>
            )}
            <TextField
              label={languages.structure.pointsLoss}
              value={scoreType.pointsLoss || ""}
              placeholder="0"
              name="pointsLoss"
              type="number"
              onChange={(e) => {
                props.handleChange(e, typeKey);
              }}
              margin="normal"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              disabled={
                scoreType.goalsAsPoints && scoreType.advancedGroupRanking
              }
            />
            <br />
            {scoreType.advancedGroupRanking && (
              <>
                <TextField
                  label={languages.structure.pointsLossOnPenalties}
                  value={scoreType.pointsLossOnPenalties || ""}
                  placeholder="0"
                  name="pointsLossOnPenalties"
                  type="number"
                  onChange={(e) => {
                    props.handleChange(e, typeKey);
                  }}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={scoreType.goalsAsPoints}
                />
                <br />
                <FormGroup style={{ marginTop: 5 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={scoreType.noDraw || false}
                        onChange={(e, checked) => {
                          props.handleSwitch(e, checked, typeKey);
                        }}
                        color="primary"
                        name="noDraw"
                      />
                    }
                    label={languages.structure.noDraw}
                  />
                  <FormHelperText style={{ marginTop: 0 }}>
                    {languages.structure.noDrawDescription}
                  </FormHelperText>
                </FormGroup>
                <FormGroup style={{ marginTop: 5 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={scoreType.goalsAsPoints || false}
                        onChange={(e, checked) => {
                          props.handleSwitch(e, checked, typeKey);
                        }}
                        color="primary"
                        name="goalsAsPoints"
                      />
                    }
                    label={languages.structure.goalsAsPoints}
                  />
                  <FormHelperText style={{ marginTop: 0 }}>
                    {languages.structure.goalsAsPointsDescription}
                  </FormHelperText>
                </FormGroup>
              </>
            )}
            <FormGroup style={{ marginTop: 5 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={scoreType.enterPenaltyScores || false}
                    onChange={(e, checked) => {
                      props.handleSwitch(e, checked, typeKey);
                    }}
                    color="primary"
                    name="enterPenaltyScores"
                  />
                }
                label={languages.formatString(
                  languages.structure.enterPenaltyScores,
                  scoreType.advancedGroupRanking && scoreType.noDraw
                    ? ""
                    : "KO-"
                )}
              />
              <FormHelperText style={{ marginTop: 0 }}>
                {languages.structure.enterPenaltyScoresDescription}
              </FormHelperText>
            </FormGroup>
            {scoreType.enterPenaltyScores && scoreType.noDraw && (
              <FormGroup style={{ marginTop: 10, marginLeft: 20 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={scoreType.includePenaltiesInGoals || false}
                      onChange={(e, checked) => {
                        props.handleSwitch(e, checked, typeKey);
                      }}
                      color="primary"
                      name="includePenaltiesInGoals"
                    />
                  }
                  label={languages.structure.includePenaltiesInGoals}
                />
              </FormGroup>
            )}
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <Typography variant="subtitle2">
                {languages.tiebreakers.rankingLabel}
              </Typography>
              <FormHelperText>
                {languages.formatString(
                  languages.tiebreakers.rankingDescription,
                  props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
              </FormHelperText>

              <div
                style={{
                  display: "flex",
                  gap: 5,
                  alignItems: "stretch",
                  marginTop: 10,
                  flexWrap: "wrap",
                }}
                className={tiebreakers.length < 6 ? classes.noWrapDesktop : ""}
              >
                {tiebreakers.map((t, i) => {
                  let tiebreaker = Tiebreakers[t.id];
                  if (t.custom && (props.tournament.customPoints || {})[t.id]) {
                    tiebreaker = {
                      id: t.id,
                      label: (
                        <span>
                          {((props.tournament.customPoints || {})[t.id] || {})
                            .name || ""}
                        </span>
                      ),
                    };
                  }
                  return (
                    <div
                      key={i}
                      style={{ display: "flex", gap: 5, alignItems: "stretch" }}
                    >
                      <div
                        style={{
                          backgroundColor: "#EDEFF1",
                          padding: "5px 10px",
                          borderRadius: 5,
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        {useSets && tiebreaker.label_sets
                          ? tiebreaker.label_sets
                          : tiebreaker.label}
                      </div>
                      {tiebreakers.length > i + 1 && (
                        <div
                          style={{
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronRightIcon
                            style={{
                              height: 15,
                              width: 15,
                              position: "relative",
                            }}
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              <TiebreakersContainer
                tiebreakers={tiebreakers}
                useSets={(scoreType.useSets || "0") !== "0"}
                tournament={props.tournament}
                scoreTypeKey={typeKey}
              />
            </FormControl>
          </div>
        )}
        {(scoreType.useSets || "0") === "1" && (
          <div>
            <TextField
              label={languages.structure.numSets}
              value={scoreType.numSets || ""}
              placeholder="2"
              name="numSets"
              type="number"
              onChange={(e) => {
                props.handleChange(e, typeKey);
              }}
              margin="normal"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
            {Number(scoreType.numSets || "2") % 2 === 0 && (
              <div>
                <FormGroup style={{ marginTop: 5 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={scoreType.decidingSet || false}
                        onChange={(e, checked) => {
                          props.handleSwitch(e, checked, typeKey);
                        }}
                        color="primary"
                        name="decidingSet"
                      />
                    }
                    label={languages.structure.decidingSet}
                  />
                </FormGroup>
                {scoreType.decidingSet && (
                  <FormGroup style={{ marginLeft: 25 }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={scoreType.decidingSetPoints || false}
                          onChange={(e, checked) => {
                            props.handleSwitch(e, checked, typeKey);
                          }}
                          color="primary"
                          name="decidingSetPoints"
                        />
                      }
                      label={languages.structure.decidingSetPoints}
                    />
                  </FormGroup>
                )}
              </div>
            )}

            {Number(scoreType.numSets || "2") % 2 !== 0 &&
              Number(scoreType.numSets || "2") > 1 &&
              (scoreType.setsType || 0) === 0 && (
                <div>
                  <FormGroup style={{ marginTop: 5 }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={scoreType.playOff || false}
                          onChange={(e, checked) => {
                            props.handleSwitch(e, checked, typeKey);
                          }}
                          color="primary"
                          name="playOff"
                        />
                      }
                      label={languages.formatString(
                        languages.structure.playOffMode,
                        scoreType.numSets
                      )}
                    />
                  </FormGroup>
                </div>
              )}

            <FormControl style={{ width: "100%", marginTop: 15 }}>
              <InputLabel style={{ width: "100%" }} htmlFor="setsType">
                {languages.structure.setsTypeLabel}
              </InputLabel>
              <Select
                style={{ maxWidth: "100%" }}
                value={scoreType.setsType || 0}
                onChange={(e) => {
                  props.handleChange(e, typeKey);
                }}
                inputProps={{
                  name: "setsType",
                  id: "setsType",
                }}
              >
                <MenuItem value={0}>
                  {languages.structure.overTotalSets}
                </MenuItem>
                <MenuItem value={1}>{languages.structure.perSet}</MenuItem>
              </Select>
            </FormControl>
            {(scoreType.setsType || 0) === 0 ? (
              <div style={{ marginTop: 15 }}>
                {possibleResults.map((result, i) => {
                  return (
                    <div key={i}>
                      <div style={{ marginTop: 5 }}>
                        {languages.structure.pointsForResult + " " + result}
                      </div>
                      <TextField
                        style={{ marginRight: 15, marginTop: 0 }}
                        label={languages.structure.winner}
                        value={
                          ((scoreType.gamePoints || {})[result] || {}).winner ||
                          ""
                        }
                        placeholder="2"
                        name="winner"
                        type="number"
                        onChange={(e) => {
                          props.handleGamePointsChange(e, result, typeKey);
                        }}
                        margin="normal"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <TextField
                        style={{ marginTop: 0 }}
                        label={languages.structure.loser}
                        value={
                          ((scoreType.gamePoints || {})[result] || {}).loser ||
                          ""
                        }
                        placeholder="0"
                        name="loser"
                        type="number"
                        onChange={(e) => {
                          props.handleGamePointsChange(e, result, typeKey);
                        }}
                        margin="normal"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                  );
                })}
                {Number(scoreType.numSets || "2") % 2 === 0 &&
                  (scoreType.decidingSet || false) === false && (
                    <div>
                      <div style={{ marginTop: 5 }}>
                        {languages.structure.pointsForResult +
                          " " +
                          (Number(scoreType.numSets || "2") / 2).toString() +
                          "-" +
                          (Number(scoreType.numSets || "2") / 2).toString()}
                      </div>
                      <TextField
                        style={{ marginTop: 0 }}
                        label={languages.formatString(
                          languages.structure.both,
                          props.tournament.individualPlayers
                            ? languages.teams.playersLow
                            : languages.tournament.teamsLow
                        )}
                        value={
                          (
                            (scoreType.gamePoints || {})[
                              (
                                Number(scoreType.numSets || "2") / 2
                              ).toString() +
                                "-" +
                                (
                                  Number(scoreType.numSets || "2") / 2
                                ).toString()
                            ] || {}
                          ).winner || ""
                        }
                        placeholder="1"
                        name="winner"
                        type="number"
                        onChange={(e) => {
                          props.handleGamePointsChange(
                            e,
                            (Number(scoreType.numSets || "2") / 2).toString() +
                              "-" +
                              (Number(scoreType.numSets || "2") / 2).toString(),
                            typeKey
                          );
                        }}
                        margin="normal"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                  )}
              </div>
            ) : (
              <div>
                <TextField
                  label={languages.structure.pointsWin}
                  value={scoreType.pointsWin || ""}
                  placeholder="3"
                  name="pointsWin"
                  type="number"
                  onChange={(e) => {
                    props.handleChange(e, typeKey);
                  }}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <br />
                <TextField
                  label={languages.structure.pointsTie}
                  value={scoreType.pointsTie || ""}
                  placeholder="1"
                  name="pointsTie"
                  type="number"
                  onChange={(e) => {
                    props.handleChange(e, typeKey);
                  }}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <br />
                <TextField
                  label={languages.structure.pointsLoss}
                  value={scoreType.pointsLoss || ""}
                  placeholder="0"
                  name="pointsLoss"
                  type="number"
                  onChange={(e) => {
                    props.handleChange(e, typeKey);
                  }}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            )}
            <FormControl style={{ width: "100%", marginTop: 20 }}>
              <Typography variant="subtitle2">
                {languages.tiebreakers.rankingLabel}
              </Typography>
              <FormHelperText>
                {languages.formatString(
                  languages.tiebreakers.rankingDescription,
                  props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
              </FormHelperText>
              <div
                style={{
                  display: "flex",
                  gap: 5,
                  alignItems: "stretch",
                  marginTop: 10,
                  flexWrap: "wrap",
                }}
                className={tiebreakers.length < 6 ? classes.noWrapDesktop : ""}
              >
                {tiebreakers.map((t, i) => {
                  let tiebreaker = Tiebreakers[t.id];
                  if (t.custom) {
                    tiebreaker = {
                      id: t.id,
                      label: (
                        <span>
                          {((props.tournament.customPoints || {})[t.id] || {})
                            .name || ""}
                        </span>
                      ),
                    };
                  }
                  return (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        gap: 5,
                        alignItems: "stretch",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#EDEFF1",
                          padding: "5px 10px",
                          borderRadius: 5,
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        {useSets && tiebreaker.label_sets
                          ? tiebreaker.label_sets
                          : tiebreaker.label}
                      </div>
                      {tiebreakers.length > i + 1 && (
                        <div
                          style={{
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronRightIcon
                            style={{
                              height: 15,
                              width: 15,
                              position: "relative",
                            }}
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              <TiebreakersContainer
                tiebreakers={tiebreakers}
                useSets={(scoreType.useSets || "0") !== "0"}
                tournament={props.tournament}
                scoreTypeKey={typeKey}
              />
            </FormControl>

            {/* <div>
              <Typography style={{ marginTop: 10 }}>
                {languages.scoreCalculationLabel}
                <Tooltip title={languages.scoreCalculationSets}>
                  <InfoIcon
                    style={{
                      height: 15,
                      width: 15,
                      marginLeft: 5,
                      position: "relative",
                      top: 2,
                    }}
                  />
                </Tooltip>
              </Typography>
            </div> */}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

function ScoreCountCard(props) {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <ExpansionPanel style={{ boxShadow: "none" }}>
        <ExpansionPanelSummary
          style={{ paddingLeft: 0, paddingRight: 0 }}
          expandIcon={<ExpandMoreIcon />}
        >
          <div style={{ display: "block" }}>
            <Typography variant="h6">
              {languages.structure.scoreCount}
            </Typography>
            <Typography variant="caption">
              {languages.structure.scoreCountExplanation}
            </Typography>
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ paddingLeft: 0, paddingRight: 0 }}>
          <div style={{ width: "100%" }}>
            <ScoreType props={props} typeNum={1} />
            {Object.keys(props.tournament.scoringTypes || {})
              .sort((a, b) => a - b)
              .map((key, i) => (
                <ScoreType
                  key={key}
                  props={props}
                  typeKey={key}
                  typeNum={i + 2}
                />
              ))}
            <Button
              style={{ height: 48 }}
              variant="outlined"
              color="default"
              onClick={props.handleAddScoringType}
              fullWidth
            >
              {languages.structure.addScoring}
            </Button>
            <br />
            <br />
            <div>
              <Typography variant="h6">
                {languages.structure.morePoints}
              </Typography>
              <Typography variant="caption">
                {languages.structure.morePointsDescription}
              </Typography>
              {Object.keys(props.tournament.customPoints || {}).length > 0 && (
                <table style={{ marginTop: 15, width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ fontWeight: 500 }}>
                        {languages.general.name}
                      </td>
                      <td style={{ fontWeight: 500 }}>
                        {languages.structure.abbr}
                      </td>
                    </tr>
                    {Object.keys(props.tournament.customPoints || {}).map(
                      (key) => {
                        let customPoints = props.tournament.customPoints[key];
                        customPoints["id"] = key;
                        return (
                          <tr key={key}>
                            <td style={{ width: "50%" }}>
                              <Typography>{customPoints.name}</Typography>
                            </td>
                            <td>
                              <Typography>{customPoints.abbr}</Typography>
                            </td>

                            <td style={{ padding: 0 }}>
                              <CustomPointsContainer
                                tournament={props.tournament}
                                customPoints={customPoints}
                              />
                            </td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </table>
              )}
            </div>
            <br />
            <CustomPointsContainer tournament={props.tournament} />
            <br />
            {!props.tournament.individualPlayers && (
              <div>
                <div>
                  <Typography variant="h6">
                    {languages.structure.morePointsPlayers}
                  </Typography>
                  <Typography variant="caption">
                    {languages.structure.morePointsDescriptionPlayers}
                  </Typography>
                  {Object.keys(props.tournament.playerPoints || {}).length >
                    0 && (
                    <table style={{ marginTop: 15, width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ fontWeight: 500 }}>
                            {languages.general.name}
                          </td>
                          <td style={{ fontWeight: 500 }}>
                            {languages.structure.abbr}
                          </td>
                        </tr>
                        {Object.keys(props.tournament.playerPoints || {}).map(
                          (key) => {
                            let customPoints =
                              props.tournament.playerPoints[key];
                            customPoints["id"] = key;
                            return (
                              <tr key={key}>
                                <td style={{ width: "50%" }}>
                                  <Typography>{customPoints.name}</Typography>
                                </td>
                                <td>
                                  <Typography>{customPoints.abbr}</Typography>
                                </td>

                                <td style={{ padding: 0 }}>
                                  <CustomPointsContainer
                                    tournament={props.tournament}
                                    customPoints={customPoints}
                                    playerStats={true}
                                  />
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
                <br />
                <CustomPointsContainer
                  tournament={props.tournament}
                  playerStats={true}
                />
              </div>
            )}
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}

ScoreCountCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ScoreCountCard);
